/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TConfirmPhoneModel,
  IConfirmPhoneRequest,
  IMappers,
  IConfirmPhoneResponse,
  IConfirmPhoneResponseError,
  TConfirmPhoneResponse,
} from './types';

const defaultConfig: TConfirmPhoneModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'pik-booking',
  pathApi: '/v1/confirm-phone/',
  hostType: 'api',
} as TConfirmPhoneModel;

function createConfirmPhoneModel(parameters: IConfirmPhoneRequest): TConfirmPhoneModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IConfirmPhoneOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IConfirmPhoneRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchConfirmPhone<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IConfirmPhoneOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TConfirmPhoneResponse> {
  const { response, statusCode } = await httpApi.fetch(createConfirmPhoneModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IConfirmPhoneResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IConfirmPhoneResponseError);
    }
  }

  return { response, statusCode } as TConfirmPhoneResponse;
}

export { defaultConfig, createConfirmPhoneModel, fetchConfirmPhone };
